export default __webpack_public_path__ + "static/media/banner-belconnen.5d9ca8fa.jpg";